import BaseModelInstance from './base.model'
import { AgentPackagesFeatures as ModelDefinition } from './model-definitions'

class AgentPackagesFeatures extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default AgentPackagesFeatures
